module.exports = __webpack_public_path__ + "assets/img/jp.b9508955.svg";